<template>
  <div class="view-plans auth mb-5">
    <register-logout />
    <div class="container">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <h1 class="text-center mb-5">
            <img src="@/assets/logo-white.svg" />
          </h1>

          <div class="card">
            <div v-if="loading" class="card-body p-5 text-center">
              <b-spinner variant="primary" />
            </div>
            <div v-else class="card-body p-5">
              <h1 class="d-flex flex-column text-center justify-content-center">
                {{ $t("aguardandoConfirmacao") }}
              </h1>
              <div class="text-center">
                <button class="btn btn-danger rounded-pill" @click="check">
                  {{ $t("entreContato") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "plans",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    check() {
      let url = "https://api.whatsapp.com/send/?phone=5551991722494";
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.view-plans {
  width: 100%;

  h1 {
    color: #311b41;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 35px;

    small {
      font-size: 20px;
    }
  }

  .bottom-contact {
    font-size: 14px;
    color: #311b41;
    text-align: center;
  }
}
</style>
